import { Theme, useMediaQuery } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

const useMediaUp = (breakpoint: Breakpoint | number): boolean =>
  useMediaQuery((theme: Theme) => theme.breakpoints.up(breakpoint));

export default useMediaUp;
